<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">{{ $t('barcode.items.title') }}</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

		    <v-text-field clearable elevation-10  flat solo :placeholder="$t('barcode.items.search')" v-model="searchValue" @input="fn_debounceSearch" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
		</v-toolbar>

		<div class="hasToolbar hasExtension grey-back" v-scroll="onScroll">

			<!-- <v-tabs v-model="activeIndex" @input="fn_tabChange" slider-color="primary">
				<v-tab ripple>{{ $t('barcode.items.labelPrinter') }}</v-tab>
				<v-tab ripple>{{ $t('barcode.items.regularPrinter') }}</v-tab>
			</v-tabs>

			<v-tabs-items v-model="activeIndex" @input="fn_tabChange">

				<v-tab-item grey-back>  
					<v-list nopadding grey-back>

						<div white-background v-for="(item, index) in filteredItems" :key="index">
							<v-list-tile class="right-subtitle-tile">
								<v-list-tile-content @click="fn_itemClick(item.barcodeTemplateId, index)">
								<v-list-tile-title class="mb-1" data-no-translate>{{item.labelName}}</v-list-tile-title>
								</v-list-tile-content>

								<v-list-tile-action>
									<v-btn icon flat @click="fn_getBottomMenu(null, 902, item)">
										<v-icon>more_vert</v-icon>
									</v-btn>
								</v-list-tile-action>
							</v-list-tile>

							<v-divider v-if="filteredItems.length-1 != index"></v-divider>
						</div>


					</v-list>
				</v-tab-item>

				<v-tab-item>  
					<keep-alive>
						<v-list nopadding grey-back>

							<div white-background v-for="(item, index) in filteredItems" :key="index">
								<v-list-tile class="right-subtitle-tile">
									<v-list-tile-content @click="fn_itemClick(item.barcodeTemplateId, index)">
									<v-list-tile-title class="mb-1" data-no-translate>{{item.labelName}}</v-list-tile-title>
									</v-list-tile-content>

									<v-list-tile-action>
										<v-btn icon flat @click="fn_getBottomMenu(null, 902, item)">
											<v-icon>more_vert</v-icon>
										</v-btn>
									</v-list-tile-action>
								</v-list-tile>

								<v-divider v-if="filteredItems.length-1 != index"></v-divider>
							</div>


						</v-list>
					</keep-alive>
				</v-tab-item>

			</v-tabs-items> -->

			<v-list nopadding>
				<!-- do not remove selection for printer type -->
				<!-- <v-subheader style="position: sticky;top: 104px;z-index: 1;" white-background subheader-dense>
					Count: {{$root.numberToLocale(filteredItems.length, 1)}}
					<v-spacer></v-spacer>

					<div class="font11 mr-2" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" v-ripple>
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" @click="$refs['ref_dialogPrinterSelection'].dialogTypeSelection = true">
							{{ selectedPrinterType}} {{ selectedPrinterType ? 'Printer Templates' : 'Select Printer Type' }}
						</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>
				</v-subheader>

				<v-divider></v-divider> -->

				<div white-background v-for="(item, index) in filteredItems" :key="index">
					<v-list-tile class="right-subtitle-tile">
						<v-list-tile-content @click="fn_itemClick(item.barcodeTemplateId, index)">
							<v-list-tile-title class="mb-1" data-no-translate>{{item.labelName}}</v-list-tile-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-btn icon flat @click="fn_getBottomMenu(null, 902, item)">
								<v-icon>more_vert</v-icon>
							</v-btn>
						</v-list-tile-action>
					</v-list-tile>

					<v-divider v-if="filteredItems.length-1 != index"></v-divider>
				</div>
			</v-list>
			
			<!-- <div class="display_msg" v-if="!listItemObject.items.length">{{ $t('barcode.items.noTemplates') }}</div> -->
		</div>

		<!-- <dialog-printer-selection ref="ref_dialogPrinterSelection" :selectPrinterType="fn_selectPrinterType"></dialog-printer-selection> -->
		
	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../config.js').configs.bottomSheetMenu;
// import dialogPrinterSelection from './dialogs/dialog_printer_selection'

import {masterMixin} from '../masters/master_mixin.js';

	export default{
		mixins: [masterMixin],
		data(){
			return{
				selectedItemId:null,
				data:null,
				searchValue:'',
				// activeIndex:0
				selectedPrinterType:null,
				// dialogTypeSelection:false
			}
		},
		// components:{
		// 	'dialog-printer-selection':dialogPrinterSelection
		// },
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_new: function(){
				this.$router.push({path:'/barcode/designer', query:{tagId:this.guidWeb(), order_number:this.data.items.length, printer_type:this.selectedPrinterType}});
			},

			fn_menuItemClick: function(tagId, menuId, menuAction, itemId){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit'){
					// this.$router.push("/addons/discounts/"+this.selectedItemId+"/edit");
					this.fn_itemClick(this.selectedItemId);
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/barcode/designer', query:{tagId:this.guidWeb(), templateId:this.selectedItemId, order_number:this.data.items.length, copy:true}});
				}
				else if(menuAction=='draft'){
					this.$router.push({path:'/drafts', query:{tabIndex:0}});
				}
				else if(menuAction=='delete'){
					let self = this;
					this.fn_deleteMasterItem('deleteBarcodeTemplate', itemId, function(response){
						if(response){
	                        self.showToast(self.$t('barcode.items.templateDeleted'));
							let index = self.data.items.findIndex(x => x.barcodeTemplateId == itemId);
	                        self.data.items.splice(index, 1);
	                    }
	                    else{
	                        self.showToast(self.$t('barcode.items.templateInUse'));
	                    }
					})
				}
			},

			fn_itemClick: function (itemId) {
				this.$router.push({path:'/barcode/designer', query:{tagId:this.guidWeb(), templateId:itemId}});
			},

			fn_getBottomMenu: function (tagId, elementId, item) {
				let bottomMenu;

				if(elementId == bottomSheetMenu.toolBar.Id){
					bottomMenu = {"BottomMenu": [menuItem.help]};
				}
				else if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.copy]};
					!Number(item.isSystem) ? bottomMenu = {"BottomMenu": [menuItem.edit, menuItem.copy]} : '';
					this.selectedItemId = item.barcodeTemplateId;
				}
				
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_loadItems: function(search) {
		    	let filterObject = {};

				let self = this;
				this.getItems("GetBarcodeTemplates", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							self.data = JSON.parse(response);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

			fn_selectPrinterType: function(type){
				this.selectedPrinterType = type
				// this.$refs['ref_dialogPrinterSelection'].dialogTypeSelection = false;
				let obj = {printerType: type};
      			this.$root.fn_saveLocalData({LocalKey:'printerType',LocalValue:JSON.stringify(obj)});
				this.fn_loadItems();
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.query.tagId ? tagId = this.$route.query.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			}

		},
		mounted: function(){
			this.fn_showWebView();
			window.js_globals.fn_onBackPress = this.fn_goBack;

			// commented printer type as for now only enabling for Label printer
    		// Regular A4 printer code is also ready so do not remove this
			let self = this;
			this.$root.fn_getLocalData('printerType', function(response){
				if(!response || response === 'null'){
					// self.$refs['ref_dialogPrinterSelection'].dialogTypeSelection = true;
					self.fn_selectPrinterType('Label')
				}
				else{
					let typeObj = JSON.parse(response);
					self.selectedPrinterType = typeObj.printerType;
					self.fn_loadItems();
				}
			})
		},
		computed:{
			filteredItems: function () {
				let searchText = this.searchValue ? this.searchValue.toLowerCase() : '';

				if(this.data){
					return this.data.items.filter(item => {
						let labelName = item.labelName.toLowerCase();
						return labelName.match(searchText) && item.printerType == this.selectedPrinterType;
					})
				}
				
				return [];
			}
		},
		// beforeRouteLeave (to, from, next) {
		// 	if(this.$refs['ref_dialogPrinterSelection'].dialogTypeSelection){
		// 		if(!this.selectedPrinterType){
		// 			this.showToast(this.$t('barcode.items.selectPrinterType'));
		// 			next(false);
		// 		}
		// 		else{
		// 			this.this.$refs['ref_dialogPrinterSelection'].dialogTypeSelection = false;
		// 		}
		// 	}
		// 	else{
		// 		next();
		// 	}
		// }
	}
</script>


// WEBPACK FOOTER //
// src/components/barcode/items.vue